import { getCountryNameFromCode } from 'helpers/countries';
import {} from 'interfaces/countries';
export const createLockedCountryInputFormatter = (countryCodeMap) => (value) => getCountryNameFromCode(countryCodeMap, value);
